import React, { FC } from 'react'
const TrackChangeIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width="36"
        height="34"
        viewBox="0 0 36 34"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M26.111 30.3333L20.4305 24.6388L22.3749 22.6944L26.111 26.4027L33.3888 19.1249L35.3333 21.111L26.111 30.3333ZM0.333252 33.6666V3.111C0.333252 2.361 0.60871 1.71054 1.15963 1.15963C1.71054 0.608711 2.361 0.333252 3.111 0.333252H30.8888C31.6388 0.333252 32.2893 0.608711 32.8402 1.15963C33.3911 1.71054 33.6666 2.361 33.6666 3.111V15.611H30.8888V3.111H3.111V27.0694L5.80546 24.2222H17.2777V26.9999H6.99992L0.333252 33.6666Z" />
    </svg>
)
export default TrackChangeIcon
